import styled from 'styled-components';
import themedColor from '../../../../styles/theme/themed-color';
import styleUtils from '../../../../styles/style.utils';
import mediaBreakpoints from '../../../../styles/media-breakpoints';
import themedFontSize from '../../../../styles/theme/themed-font-size';

const Container = styled.div`
  border: 1px solid ${themedColor('GRAY')};
  margin-bottom: ${styleUtils.px(16)};
  padding: ${styleUtils.px(16)} ${styleUtils.px(32)};
  max-width: ${styleUtils.size('MAX_BUTTON_CONTAINER_WIDTH')};
  cursor: pointer;

  ${mediaBreakpoints.greaterThan('M')`
    border:none;
    padding:16px;
    margin: 0 ${styleUtils.px(80)};
    text-align: center;
    border-radius: ${styleUtils.px(10)};
    background: ${themedColor('GRAY')};
    transition: all 0.3s ease-in-out;

    &:hover{
      box-shadow: inset 0px 0px 0px 1px ${themedColor('INPUT_FOCUS_BORDER')};
    }

    & > p {
      height: 0;
      overflow: hidden;
      transition: all 0.3s ease-in-out;
    }
    
      &:hover {
        background:${themedColor('GRAY')};

        & > p {
          height: 60px;
        }
      }
  `};
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${styleUtils.px(16)};
  height: ${styleUtils.px(64)};

  ${mediaBreakpoints.greaterThan('M')`
    justify-content: center;
    
  `};
`;

const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const Arrow = styled.div`
  width: ${styleUtils.px(12)};
  height: ${styleUtils.px(12)};
  border-right: ${styleUtils.px(1)} solid ${themedColor('TEXT_DISABLED')};
  border-top: ${styleUtils.px(1)} solid ${themedColor('TEXT_DISABLED')};
  margin-left: auto;
  transform: rotate(45deg) translate(3px, 3px);
`;

const StyledText = styled.p`
  &.ucf-paragraph {
    font-size: ${themedFontSize('BUTTON_M')};
    color: ${themedColor('TEXT_BLUE')};
    white-space: pre;
    margin: 0;
    text-align: left;

    strong {
      font-weight: 700;
    }

    ${mediaBreakpoints.greaterThan('M')`    
      text-align: center;
    `}
  }
`;

const ExistingClientButtonComponents = {
  Container,
  TopRow,
  Logo,
  Arrow,
  StyledText
};

export default ExistingClientButtonComponents;
